<template>
	<div class="z-fullscreen-loading">
		<div>
			<div class="spinner"></div>
		</div>
	</div>
</template>

<style lang="sass" scoped>
.z-fullscreen-loading
	@apply fixed top-0 left-0 w-full h-full flex items-center justify-center bg-white
	background: radial-gradient(169.81% 85.6% at 69.48% 50%, #FFF 0%, #cad8ef 100%)
</style>